import api from '@/api/request'
import { flux } from '@/util/func'
import useStore from '@/store/pinia'

// 个人中心-用户汇总
export function getPersonalCenters(userId) {
  return api.get(`/services/common/api/personal-centers/${userId}`)
  // 红点数据：redDotHintMap
  // 订单物流信息：orderLogisticList
  // 最快过期的一张优惠券：couponRecord
  // 可用优惠券Count数：couponCount
  // 被回复数:repliedCount
  // 文章收藏数:articleCollectCount
  // 商品收藏数:productCollectCount
  // 购物车规格Count数:cartSpecCount
  // 钱包余额:balance
  // 推荐商品:productList
}

// 个人中心-返回主订单每种订单状态的订单数量
export function getPurchaseOrdersStatus(params) {
  return api.get(`/services/order/api/main/order/count`, params)
}
// ==========================================

// 2026 需求新增接口 (扩展部分)
// ==========================================

/**
 * 2.1 获取当前登录用户信息
 * @description 认证要求：需携带 Authorization: Bearer <token> 凭证
 * @returns {Promise<{ success: boolean, errorCode: string|null, errorMessage: string|null, data: Object }>} CurrentUserResult
 */
export function getCurrentUser() {
  return api
    .get(`services/user/api/current/user`)
    .then((res) => {
      console.log('getCurrentUser', res)
      // 同步将最新的当前登录用户信息沉淀到全局 Pinia Store 中
      if (res && res.success && res.data) {
        const { userStore } = useStore()
        userStore.setUserInfo(res.data)
      }
      return flux.resolve(res)
    })
    .catch((err) => {
      return flux.reject(err)
    })
}

/**
 * 2.2 更新当前用户信息
 * @description 认证要求：需携带 Authorization: Bearer <token> 凭证
 * @param {Object} data - 请求体参数 (HaiSmartUpdateUserRequest)
 * @param {string} data.givenName - 名（必填）
 * @param {string} data.familyName - 姓（必填）
 * @param {string} [data.middleName] - 中间名（可选）
 * @param {string} data.nickname - 昵称（必填）
 * @param {string} [data.birthday] - 生日 (可选，格式：yyyy-MM-dd)
 * @returns {Promise<{ success: boolean, errorCode: string|null, errorMessage: string|null }>} HaiSmartUpdateUserInfoResult
 */
export function updateCurrentUser(param) {
  return api.put(`services/user/api/update/current/user`, param)
}

/**
 * 2.3 上传用户头像
 * @description 认证要求：需携带 Authorization: Bearer <token> 凭证。支持传递原生 File 对象或 FormData 容器
 * @param {File | Blob | FormData} formData - 图片文件对象或已组装的FormData
 * @returns {Promise<{ success: boolean, errorCode: string|null, errorMessage: string|null, data: Object }>} UploadAvatarResult
 */
export function uploadAvatar(formData) {
  return api.post_file(`services/user/api/upload/avatar`, formData, {
    allowDuplicate: true,
    timeout: 120000,
  })
}

/**
 * 2.4 注销/删除当前用户
 * @description 认证要求：需携带 Authorization: Bearer <token> 凭证。执行账号注销高危操作
 * @returns {Promise<{ success: boolean, errorCode: string|null, errorMessage: string|null }>} HaiSmartDeleteUserResult
 */
export function deleteCurrentUser() {
  return api
    .delete(`services/user/api/delete/current/user`)
    .then((res) => {
      // 注销成功后，主动协助前端清理掉本地过期的 Token 或本地存储的脏数据
      if (res && res.success) {
        const { userStore } = useStore()
        // 对齐本项目既有的 Token 清理规范
        localStorage.removeItem(`${process.env.NODE_ENV}_token`)
        if (typeof userStore.setToken === 'function') {
          userStore.setToken('')
        }
        userStore.setUserInfo(null)
      }
      return flux.resolve(res)
    })
    .catch((err) => {
      return flux.reject(err)
    })
}